// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_7k-0";
export var optionCard = "_7k-1";